import { ReactNode } from 'react'
import { Loader2Icon } from 'lucide-react'

interface SpinnerProps {
  loading: boolean
  children: ReactNode
}

// Loading wheel centered on the screen, shown while the subflow or a step waits for its data
export const LoadingWheel: React.FC = () => (
  <div
    aria-live='polite'
    aria-busy='true'
    className='absolute top-[50%] left-[50%]'
  >
    <Loader2Icon aria-hidden className='size-8 animate-spin text-primary' />
  </div>
)

// Shows a loading wheel centered on the screen while the data of a step loads, then the step itself
const Spinner: React.FC<SpinnerProps> = ({ loading, children }) => {
  return loading ? <LoadingWheel /> : <>{children}</>
}

export default Spinner
